import StarIcon from "@mui/icons-material/Star";
import ListPublicProcurementActProcedures from "./List";
import CreatePublicProcurementActProcedures from "./Create";
import EditPublicProcurementActProcedures from "./Edit";
import ShowPublicProcurementActProcedures from "./Show";
//params
export const PUBLIC_PROCUREMENT_ACT_PROCEDURES = "procurement-act/procedures";

//permissions

export const resources = {
  isMenu: true,
  icon: <StarIcon />,
  name: PUBLIC_PROCUREMENT_ACT_PROCEDURES,
  title: "Процедури",
  list: <ListPublicProcurementActProcedures />,
  edit: <EditPublicProcurementActProcedures />,
  create: <CreatePublicProcurementActProcedures />,
  show: <ShowPublicProcurementActProcedures />,
  permission: "publicProcurementAct",
};

//api url
